<template>
  <div class="container bgWhite">
    <div id="printSection">
      <table width="90%" class="m-0">
        <tr>
          <td width="25%">
            <div style="width: 100px" class="float-right">
              <img src="../assets/media/logoMara.png" border="0" width="120" height="120" />
            </div>
          </td>
          <td>
            <div style="text-align: center; margin-left: 50px">
              <h5 style="font-size: 20pt" class="text-center">
                <br />MAJLIS AMANAH RAKYAT
                <br />
              </h5>
              <h5 class="title">
                <br />
                <br />
                <strong>BORANG PERMOHONAN</strong>
                <br />
                <strong>PINJAMAN PELAJARAN MARA</strong>
                <br />
                <strong v-if="null!=Intakes[0]">{{Intakes[0].StartDt | moment("YYYY")}}</strong>
                <br />
              </h5>
            </div>
          </td>
          <td width="25%" class="float-right">
            <div
              style="
                border: 1px solid #000;
                width: 150px;
                height: 180px;
                margin-top: 30px;
              "
              class="float-right"
            >
              <p class="mt-5 m-3">
                Gambar saiz passport yang terbaru 3.5cm x 4.5cm
              </p>
            </div>
          </td>
        </tr>
      </table>
      <br />
      <div style="text-align: center">
        <small>
          BAHAGIAN PENGANJURAN PELAJARAN TINGKAT 10, IBU PEJABAT MARA, 21, JALAN MARA, 50609 KUALA LUMPUR
        </small>
        <br />
        <small>NO. TELEFON 03-2613 2000 NO. FAX 03-26983144</small>
      </div>
      <table>
        <div class="card-body">
          <hr class="font-weight-bold" />
          <h6 class="text-uppercase">{{ ProgrammeName }}</h6>
          <hr class="font-weight-bold" />
          <strong>BAHAGIAN I - BUTIR-BUTIR PERIBADI</strong>
          <hr class="font-weight-bold" />
        </div>
      </table>
      <div class="card-body">
        <div>
          <div class="clearfix"></div>
          <table width="100%">
            <tbody>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase">
                  <span class="font-weight-bold">Nama Penuh</span>
                </td>
                <td class="ml-2 mr-2">:</td>
                <td><span style="text-transform: uppercase">{{ FirstName }}</span></td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Tarikh Lahir</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ moment(PersonalBirthDt).locale("ms-my").format("DD MMM YYYY") }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">NO. K/P Baru</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalIdentityNo }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Tempat Lahir</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalBirthState }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Jantina</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalSex }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Agama</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalReligion }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Kewarganegaraan</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalNationalityName }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Alamat Tetap</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">
                  {{ PersonalAddress1 }} {{ PersonalAddress2 }}
                  {{ PersonalAddress3 }} {{ PersonalCity }} {{ PersonalState }}
                  {{ PersonalCountry }}
                </td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Poskod</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalPostCode }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold" style="text-align: left">Alamat Surat Menyurat</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">
                  {{ MailAddress1 }} {{ MailAddress2 }} {{ MailAddress3 }}
                  {{ MailCities }} {{ MailStates }} {{ MailCountries }}
                </td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Poskod</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ MailPostCode }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">No. Telefon Rumah</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalFixPhoneNo }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">No. Telefon Bimbit</td>
                <td class="ml-2 mr-2">:</td>
                <td class="text-uppercase">{{ PersonalMobileNo }}</td>
              </tr>
              <tr style="vertical-align: top;">
                <td class="title text-uppercase font-weight-bold">Emel</td>
                <td class="ml-2 mr-2">:</td>
                <td>{{ PersonalEmail }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <table>
        <div class="card-body">
          <hr class="font-weight-bold" />
          <strong>BAHAGIAN II - BUTIR-BUTIR CADANGAN PENGAJIAN</strong>
          <hr class="font-weight-bold" />
        </div>
      </table>
      <div class="card-body">
        <div>
          <div class="clearfix"></div>
          <table width="100%">
            <tbody>
              <tr>
                <td class="title text-uppercase" width="200px">
                  <span class="font-weight-bold">NAMA SEKOLAH</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ SchoolName }}</span>
                </td>
              </tr>
              <tr>
                <td class="title text-uppercase">
                  <span class="font-weight-bold">ANGKA GILIRAN SPM</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ SPMTurnNumber }}</span>
                </td>
              </tr>
              <tr>
                <td class="title text-uppercase">
                  <span class="font-weight-bold">ZON TEMUDUGA</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ InterviewZoneName }}</span>
                </td>
              </tr>
              <tr>
                <td class="title text-uppercase">
                  <span class="font-weight-bold">MARKAH KOKURIKULUM</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ KokuMarks }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <div class="clearfix"></div>
          <br>
          <u><span class="title text-uppercase font-weight-bold">PILIHAN PERTAMA</span></u>
          <table width="100%">
            <tbody>
              <tr>
                <td class="title text-uppercase" width="200px">
                  <span class="font-weight-bold">NAMA KURSUS</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ YTPCourse1Name }}</span>
                </td>
              </tr>
              <tr>
                <td class="title text-uppercase">
                  <span class="font-weight-bold">NAMA IPT</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ YTPCourse1IPT }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <div class="clearfix"></div>
          <br>
          <u><span class="title text-uppercase font-weight-bold">PILIHAN KEDUA</span></u>
          <table width="100%">
            <tbody>
              <tr>
                <td class="title text-uppercase" width="200px">
                  <span class="font-weight-bold">NAMA KURSUS</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ YTPCourse2Name }}</span>
                </td>
              </tr>
              <tr>
                <td class="title text-uppercase">
                  <span class="font-weight-bold">NAMA IPT</span>
                </td>
                <td>
                  :
                  <span style="text-transform: uppercase">{{ YTPCourse2IPT }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p style="page-break-before: always"></p>
      <table>
        <div class="card-body">
          <hr class="font-weight-bold" />
          <strong>BAHAGIAN III - BUTIR-BUTIR KELUARGA</strong>
          <hr class="font-weight-bold" />
        </div>
      </table>
      <div class="card-body">
        <div>
          <label>
            <strong>A. Butir-butir Mengenai Ibu Bapa/Penjaga Pemohon.</strong>
          </label>
        </div>
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="font-weight-bold" width="25%">BUTIRAN</th>
              <th class="font-weight-bold" width="25%">BAPA</th>
              <th class="font-weight-bold" width="25%">IBU</th>
              <th class="font-weight-bold" width="25%">PENJAGA</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="title text-uppercase font-weight-bold">Nama Penuh</td>
              <td class="text-uppercase" style="text-align: left;">{{ FatherName }}</td>
              <td class="text-uppercase" style="text-align: left;">{{ MotherName }}</td>
              <td class="text-uppercase" style="text-align: left;">{{ GuardianName }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold" style="text-align: left;">
                No. Kad Pengenalan Baru
              </td>
              <td class="text-uppercase">{{ FatherIdentityNo }}</td>
              <td class="text-uppercase">{{ MotherIdentityNo }}</td>
              <td class="text-uppercase">{{ GuardianIdentityNo }}</td>
            </tr>
            <!-- <tr>
              <td class="title text-uppercase font-weight-bold">No. Kad Pengenalan Lama</td>
              <td class="text-uppercase">{{FatherOldIdentityNo}}</td>
              <td class="text-uppercase">{{MotherOldIdentityNo}}</td>
              <td class="text-uppercase">{{GuardianOldIdentityNo}}</td>
            </tr>-->
            <tr>
              <td class="title text-uppercase font-weight-bold">
                Alamat Tetap
              </td>
              <td class="text-uppercase" style="text-align: left;">
                {{ FatherAddress1 }} {{ FatherAddress2 }} {{ FatherAddress3 }}
                {{ FatherCity }} {{ FatherPostcode }} {{ FatherState }}
                {{ FatherCountry }}
              </td>
              <td class="text-uppercase" style="text-align: left;">
                {{ MotherAddress1 }} {{ MotherAddress2 }} {{ MotherAddress3 }}
                {{ MotherCity }} {{ MotherPostcode }} {{ MotherState }}
                {{ MotherCountry }}
              </td>
              <td class="text-uppercase" style="text-align: left;">
                {{ GuardianAddress1 }} {{ GuardianAddress2 }}
                {{ GuardianAddress3 }} {{ GuardianCity }}
                {{ GuardianPostcode }} {{ GuardianState }} {{ GuardianCountry }}
              </td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">No. Telefon</td>
              <td class="text-uppercase">{{ FatherNoTel }}</td>
              <td class="text-uppercase">{{ MotherNoTel }}</td>
              <td class="text-uppercase">{{ GuardianNoTel }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">
                Tempat Lahir
              </td>
              <td class="text-uppercase">{{ FatherBirthState }}</td>
              <td class="text-uppercase">{{ MotherBirthState }}</td>
              <td class="text-uppercase">{{ GuardianBirthState }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">
                Kewarganegaraan
              </td>
              <td class="text-uppercase">{{ FatherNationalityName }}</td>
              <td class="text-uppercase">{{ MotherNationalityName }}</td>
              <td class="text-uppercase">{{ GuardianNationalityName }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">Agama</td>
              <td class="text-uppercase">{{ FatherReligion }}</td>
              <td class="text-uppercase">{{ MotherReligion }}</td>
              <td class="text-uppercase">{{ GuardianReligion }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">
                Taraf Pekerjaan
              </td>
              <td class="text-uppercase">{{ FatherSector }}</td>
              <td class="text-uppercase">{{ MotherSector }}</td>
              <td class="text-uppercase">{{ GuardianSector }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">Pekerjaan</td>
              <td class="text-uppercase">{{ FatherTypeOfWork }}</td>
              <td class="text-uppercase">{{ MotherTypeOfWork }}</td>
              <td class="text-uppercase">{{ GuardianTypeOfWork }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">
                Nama Majikan
              </td>
              <td class="text-uppercase" style="text-align: left;">{{ FatherEmployerName }}</td>
              <td class="text-uppercase" style="text-align: left;">{{ MotherEmployerName }}</td>
              <td class="text-uppercase" style="text-align: left;">{{ GuardianEmployerName }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">
                Alamat Majikan
              </td>
              <td class="text-uppercase" style="text-align: left;">
                {{ FatherEmploymentAddress1 }} {{ FatherEmploymentAddress2 }}
                {{ FatherEmploymentAddress3 }} {{ FatherEmploymentCity }}
                {{ FatherEmploymentPostcode }} {{ FatherEmploymentState }}
                {{ FatherEmploymentCountry }}
              </td>
              <td class="text-uppercase" style="text-align: left;">
                {{ MotherEmploymentAddress1 }} {{ MotherEmploymentAddress2 }}
                {{ MotherEmploymentAddress3 }} {{ MotherEmploymentCity }}
                {{ MotherEmploymentPostcode }} {{ MotherEmploymentState }}
                {{ MotherEmploymentCountry }}
              </td>
              <td class="text-uppercase" style="text-align: left;">
                {{ GuardianEmploymentAddress1 }}
                {{ GuardianEmploymentAddress2 }}
                {{ GuardianEmploymentAddress3 }} {{ GuardianEmploymentCity }}
                {{ GuardianEmploymentPostcode }} {{ GuardianEmploymentState }}
                {{ GuardianEmploymentCountry }}
              </td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">
                No. Telefon Pejabat
              </td>
              <td class="text-uppercase">{{ FatherEmploymentContact }}</td>
              <td class="text-uppercase">{{ MotherEmploymentContact }}</td>
              <td class="text-uppercase">{{ GuardianEmploymentContact }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold" style="text-align: left;">
                Pendapatan Sebulan/Bercukai Tahunan (RM) (Sertakan Borang BE dan
                Slip Gaji)
              </td>
              <td class="text-uppercase">
                RM {{ FatherMonthlyIncome }} / RM {{ FatherYearlyIncome }}
              </td>
              <td class="text-uppercase">
                RM {{ MotherMonthlyIncome }} / RM {{ MotherYearlyIncome }}
              </td>
              <td class="text-uppercase">
                RM {{ GuardianMonthlyIncome }} / RM {{ GuardianYearlyIncome }}
              </td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold" style="text-align: left;">
                Sumber Pendapatan Lain (RM)
              </td>
              <td class="text-uppercase">RM {{ FatherOtherIncome }}</td>
              <td class="text-uppercase">RM {{ MotherOtherIncome }}</td>
              <td class="text-uppercase">RM {{ GuardianOtherIncome }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold">
                No. Cukai Pendapatan
              </td>
              <td class="text-uppercase">{{ FatherIncomeTaxNo }}</td>
              <td class="text-uppercase">{{ MotherIncomeTaxNo }}</td>
              <td class="text-uppercase">{{ GuardianIncomeTaxNo }}</td>
            </tr>
            <tr>
              <td class="title text-uppercase font-weight-bold" style="text-align: left;">
                Tarikh Bersara / Meninggal (Jika Berkaitan)
              </td>
              <td class="text-uppercase"></td>
              <td class="text-uppercase"></td>
              <td class="text-uppercase"></td>
            </tr>
          </tbody>
        </table>
        <p style="page-break-before: always"></p>
        <br>
        <div>
          <label>
            <strong>B. Butir-butir anak / tanggungan (bagi calon yang telah berkahwin) atau tanggungan Ibu / Bapa / Penjaga (bagi calon yang belum berkahwin).
            </strong>
          </label>
          <br />
          <label>
            * Anak-anak yang sudah bekerja atau anak perempuan yang sudah berkahwin tidak lagi menjadi tanggungan Ibu Bapa / Penjaga
          </label>
        </div>
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="font-weight-bold">NAMA</th>
              <th class="font-weight-bold">TARIKH LAHIR</th>
              <th class="font-weight-bold">JANTINA</th>
              <th class="font-weight-bold">KAITAN</th>
              <th class="font-weight-bold">SEKOLAH/ INSTITUSI</th>
              <th class="font-weight-bold">BANTUAN PELAJARAN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in Dependent" v-bind:key="item.Id">
              <td class="text-uppercase" style="text-align: left;">{{ item.Name }}</td>
              <td class="text-uppercase" style="text-align: left;">
                {{ moment(item.BirthDt).locale("ms-my").format("DD MMM YYYY") }}
              </td>
              <td class="text-uppercase">{{ item.Sex }}</td>
              <td class="text-uppercase">{{ item.RelationshipName }}</td>
              <td class="text-uppercase" style="text-align: left;">{{ item.InstituteName }}</td>
              <td class="text-uppercase">{{ item.Scholarship }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style="page-break-before: always"></p>
      <div v-if="null!= StatusHistory && 0<StatusHistory.length && 11==StatusHistory[0].TypeId">
        <table>
          <div class="card-body">
            <hr class="font-weight-bold" />
            <strong>BAHAGIAN IV - PENJAMIN</strong>
            <hr class="font-weight-bold" />
          </div>
        </table>
        <div class="card-body">
          <div>
            <div class="clearfix"></div>
            <u><span class="title text-uppercase font-weight-bold">A. Maklumat Penjamin 1</span></u>
            <table width="100%">
              <tbody>
                <tr>
                  <td class="title text-uppercase" width="250px">
                    <span class="font-weight-bold">Nama Penuh</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor1.Name }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">No. Kad Pengenalan Baru</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor1.IdentityNo }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">Pendapatan Sebulan (RM)</span>
                  </td>
                  <td>
                    :
                    <span v-if="null!=Guarantor1 && 0<Guarantor1.MonthlyIncome" style="text-transform: uppercase">{{ Guarantor1.MonthlyIncome }}</span>
                    <span v-else style="text-transform: uppercase"></span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">Alamat Tetap</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor1.Address }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">Poskod</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor1.Postcode }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">No. Telefon</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor1.MobileNo }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-body" v-if="1==YTPPath">
          <div>
            <div class="clearfix"></div>
            <u><span class="title text-uppercase font-weight-bold">B. Maklumat Penjamin 2</span></u>
            <table width="100%">
              <tbody>
                <tr>
                  <td class="title text-uppercase" width="250px">
                    <span class="font-weight-bold">Nama Penuh</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor2.Name }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">No. Kad Pengenalan Baru</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor2.IdentityNo }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">Pendapatan Sebulan (RM)</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor2.MonthlyIncome }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">Alamat Tetap</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor2.Address }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">Poskod</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor2.Postcode }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-uppercase">
                    <span class="font-weight-bold">No. Telefon</span>
                  </td>
                  <td>
                    :
                    <span style="text-transform: uppercase">{{ Guarantor2.MobileNo }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <table>
        <div class="card-body">
          <hr class="font-weight-bold" />
          <strong v-if="null!= StatusHistory && 0<StatusHistory.length && 11==StatusHistory[0].TypeId">
            BAHAGIAN V - PENGAKUAN
          </strong>
          <strong v-else>BAHAGIAN IV - PENGAKUAN</strong>
          <hr class="font-weight-bold" />
        </div>
      </table>
      <div class="card-body">
        <div>
          <label>
            <strong>
              PENGAKUAN : Saya mengaku bahawa segala kenyataan di atas adalah
              benar. Saya faham pihak MARA berhak menolak permohonan / menarik
              balik bantuan sekiranya maklumat di atas didapati salah /
              palsu.
            </strong>
          </label>
        </div>
        <br />
        <br />
        <br />
        <br />
        <div>
          <label>
            <strong>TANDATANGAN PEMOHON</strong>
          </label>
        </div>
        <br />
        <br />
        <br />
        <br />
        <table class="wrap-table">
          <tbody>
            <tr>
              <td class="title font-weight-bold">NAMA:</td>
            </tr>
            <br />
            <tr>
              <td class="title font-weight-bold">TARIKH:</td>
            </tr>
          </tbody>
        </table>
        <!--
        <br>
        <br>
        <p class="mt-2">
Nota :  Cetakan slip pengesahan dan borang permohonan adalah untuk simpanan pemohon sahaja, TIDAK PERLU dihantar kepada MARA. Borang permohonan ini adalah versi terkini yang telah dikemaskini pada 16 Jun 2023. 
        </p>
        -->
      </div>
      <!--
      <p style="page-break-before: always"></p>
      <div class="card-body">
        <template>
          <strong>LAMPIRAN</strong>
          <br>
          <br>
          <table class="table table-bordered">
            <thead>
              <th style="vertical-align: top;">Bil</th>
              <th style="vertical-align: top;">
               Sila hantar hardcopy dokumen yang telah dimuatnaik ke Sistem semasa permohonan bersama borang permohonan. NOTA: Sekira pelajar gagal menyertakan kesemua dokumen seperti di bawah, permohonan pelajar tidak akan diproses. Harap maklum.
              </th>
              <th style="vertical-align: top;">Tandakan (x) jika disertakan</th>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Salinan kad pengenalan (depan & belakang serta dipalangkan) pemohon</td>
                <td></td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Salinan Sijil Kelahiran / Sijil Pengangkatan (bagi anak angkat) pemohon (jika berkaitan)</td>
                <td></td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Salinan sijil SPM / IGCSE atau setara yang berkaitan</td>
                <td></td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Salinan Sijil Markah Kokurikulum (Pelaporan Pentaksiran Aktiviti Jasmani Sukan dan Kokurikulum)</td>
                <td></td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Karangan mengenai perihal diri, perancangan pengajian dan kerjaya</td>
                <td></td>
              </tr>
              <tr>
                <td>6.</td>
                <td>Salinan kad pengenalan ibu dan bapa / penjaga (depan & belakang)</td>
                <td></td>
              </tr>
              <tr>
                <td>7.</td>
                <td>Salinan sijil kelahiran ibu dan bapa / penjaga</td>
                <td></td>
              </tr>
              <tr>
                <td>8.</td>
                <td>Salinan sijil kematian atau perceraian ibu dan bapa / penjaga (jika berkaitan)</td>
                <td></td>
              </tr>
              <tr>
                <td>9.</td>
                <td>Salinan Penyata Gaji terkini ibu dan bapa / penjaga yang bekerja. Penyata Pencen bagi yang telah bersara. Surat Pengesahan Pendapatan ibu dan bapa / penjaga jika bekerja sendiri / tidak bekerja.</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <p class="mt-2">NOTA</p>
          <p class="mt-2">
            * Permohonan pelajar tidak akan diproses, sekiranya pelajar / ibu / bapa / penjaga <strong>disenarai hitamkan atau sedang dalam TINDAKAN UNDANG-UNDANG MARA.</strong>
          </p>
          <p class="mt-2">
            * Penyata pendapatan hendaklah disahkan oleh majikan. Bagi bekerja
            sendiri / berniaga / pesara perlu mengemukakan surat pengesahan
            pendapatan / penyata pencen yang telah disahkan oleh pegawai yang
            telah diberi kuasa
            <strong>(sila rujuk kepada Prosedur Pengisian Dokumen Tawaran Pinjaman Pelajaran MARA)</strong>
          </p>
        </template>
      </div>
      -->
      <!--
      <div class="card-body">
        <table class="mt-1 table table-bordered">
          <thead>
            <th colspan="3" class="text-center">UNTUK KEGUNAAN PEJABAT</th>
          </thead>
          <tbody>
            <tr>
              <td style="width: 40%">
                <table class="table table-bordered no-bordered">
                  <tbody>
                    <tr>
                      <td>Disemak</td>
                      <td>:</td>
                      <td>___________________________________</td>
                    </tr>
                    <tr>
                      <td>Tarikh</td>
                      <td>:</td>
                      <td>___________________________________</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td style="width: 30%">
                <table class="table table-bordered no-bordered">
                  <tbody>
                    <tr>
                      <td colspan="2">Lengkap</td>
                      <td>
                        <div class="box"></div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">Tidak Lengkap</td>
                      <td>
                        <div class="box"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td style="width: 30%">
                <table class="table table-bordered no-bordered">
                  <tbody>
                    <tr>
                      <td colspan="2">Layak</td>
                      <td>
                        <div class="box"></div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">Tidak Layak</td>
                      <td>
                        <div class="box"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <span class="text-left"> NOTA (Jika perlu) </span>
                <p class="mt-2">
                  ___________________________________________________________________________________________________________________________
                </p>
                <p>
                  ___________________________________________________________________________________________________________________________
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      -->
    </div>
    <b-row>
      <b-col sm="12" class="float-right">
        <b-button
          class="btn btn-lg float-right"
          type="submit"
          variant="primary"
          v-on:click="PrintSection"
        >
          <i class="fa icon-printer"></i> Cetak
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";
import Vue from "vue";
import { isDate } from "moment";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "PersonalDetails",
  components: {
    DefaultOption,
  },
  data: function () {
    return {
      Error: false,
      Message: "",

      AppId: 0,
      Intake: 0,
      PersonalIdentityNo: "",
      PersonalIdentityNoOther: "",
      PersonalReligion: "",
      PersonalBirthDt: "",
      PersonalBirthState: "",
      PersonalReligion: "",
      PersonalSex: "",
      FirstName: "",
      ProgrammeCode: "",
      ProgrammeName: "",
      InstituteId: 0,
      InstituteName: "",
      InstituteNameOther: "",
      FieldId: 0,
      FieldName: "",
      Course1Code: "",
      Course1Name: "",
      CourseDurationMonth: 0,
      PersonalNationalityName: "",
      MaritalStatus: "",
      MaritalStatusName: "",
      PersonalEthnic: "",
      PersonalAddress1: "",
      PersonalAddress2: "",
      PersonalAddress3: "",
      PersonalCity: "",
      PersonalState: "",
      PersonalCountry: "",
      PersonalPostCode: "",
      MailAddress1: "",
      MailAddress2: "",
      MailAddress3: "",
      MailCities: "",
      MailStates: "",
      MailCountries: "",
      MailPostCode: "",
      PersonalFixPhoneNo: "",
      PersonalMobileNo: "",
      PersonalEmail: "",
      BankName: "",
      BankAccountNo: "",
      StartDt: "",
      StartDtCommon: "",
      EndDtCommon: "",
      EndDt: "",
      durationMonth: 0,

      FatherName: "",
      FatherOldIdentityNo: "",
      FatherIdentityNo: "",
      FatherNoTel: "",
      FatherRetirementDt: "",
      FatherAddress1: "",
      FatherAddress2: "",
      FatherAddress3: "",
      FatherCity: "",
      FatherState: "",
      FatherPostcode: "",
      FatherCountry: "",
      FatherBirthDt: "",
      FatherBirthState: "",
      FatherBirthDtOtherState: "",
      FatherNationalityName: "",
      FatherReligion: "",
      FatherSector: "",
      FatherTypeOfWork: "",
      FatherEmploymentAddress1: "",
      FatherEmploymentAddress2: "",
      FatherEmploymentAddress3: "",
      FatherEmploymentCity: "",
      FatherEmploymentState: "",
      FatherEmploymentCountry: "",
      FatherEmploymentPostcode: "",
      FatherEmploymentContact: "",
      FatherMonthlyIncome: "",
      FatherYearlyIncome: "",
      FatherOtherIncome: "",
      FatherIncomeTaxNo: "",
      FatherEmployerName: "",
      MotherName: "",
      MotherOldIdentityNo: "",
      MotherIdentityNo: "",
      MotherNoTel: "",
      MotherRetirementDt: "",
      MotherAddress1: "",
      MotherAddress2: "",
      MotherAddress3: "",
      MotherCity: "",
      MotherState: "",
      MotherPostcode: "",
      MotherCountry: "",
      MotherBirthDt: "",
      MotherBirthState: "",
      MotherBirthDtOtherState: "",
      MotherNationalityName: "",
      MotherReligion: "",
      MotherSector: "",
      MotherTypeOfWork: "",
      MotherEmploymentAddress1: "",
      MotherEmploymentAddress2: "",
      MotherEmploymentAddress3: "",
      MotherEmploymentCity: "",
      MotherEmploymentState: "",
      MotherEmploymentCountry: "",
      MotherEmploymentPostcode: "",
      MotherEmploymentContact: "",
      MotherMonthlyIncome: "",
      MotherYearlyIncome: "",
      MotherOtherIncome: "",
      MotherIncomeTaxNo: "",
      MotherEmployerName: "",
      GuardianName: "",
      GuardianOldIdentityNo: "",
      GuardianIdentityNo: "",
      GuardianNoTel: "",
      GuardianRetirementDt: "",
      GuardianAddress1: "",
      GuardianAddress2: "",
      GuardianAddress3: "",
      GuardianCity: "",
      GuardianState: "",
      GuardianPostcode: "",
      GuardianCountry: "",
      GuardianBirthDt: "",
      GuardianBirthState: "",
      GuardianBirthDtOtherState: "",
      GuardianNationalityName: "",
      GuardianReligion: "",
      GuardianSector: "",
      GuardianTypeOfWork: "",
      GuardianEmploymentAddress1: "",
      GuardianEmploymentAddress2: "",
      GuardianEmploymentAddress3: "",
      GuardianEmploymentCity: "",
      GuardianEmploymentState: "",
      GuardianEmploymentCountry: "",
      GuardianEmploymentPostcode: "",
      GuardianEmploymentContact: "",
      GuardianMonthlyIncome: "",
      GuardianYearlyIncome: "",
      GuardianOtherIncome: "",
      GuardianIncomeTaxNo: "",
      GuardianEmployerName: "",
      SpouseName: "",
      SpouseOldIdentityNo: "",
      SpouseIdentityNo: "",
      SpouseBirthDt: "",
      SpouseBirthState: "",
      SpouseBirthDtOtherState: "",
      SpouseNationalityName: "",
      SpouseReligion: "",
      SpouseNoTel: "",
      SpouseFixPhoneNo: "",
      SpouseAddress1: "",
      SpouseAddress2: "",
      SpouseAddress3: "",
      SpouseCity: "",
      SpouseState: "",
      SpouseCountry: "",
      SpousePostcode: "",
      SpouseSector: "",
      SpouseTypeOfWork: "",
      SpouseEmployerName: "",
      SpouseEmploymentAddress1: "",
      SpouseEmploymentAddress2: "",
      SpouseEmploymentAddress3: "",
      SpouseEmploymentCity: "",
      SpouseEmploymentState: "",
      SpouseEmploymentCountry: "",
      SpouseEmploymentPostcode: "",
      SpouseEmploymentContact: "",
      SpouseMonthlyIncome: "",
      SpouseYearlyIncome: "",
      SpouseOtherIncome: "",
      SpouseIncomeTaxNo: "",
      FamilyName: "",
      FamilyAddress1: "",
      FamilyAddress2: "",
      FamilyAddress3: "",
      FamilyCity: "",
      FamilyState: "",
      FamilyCountry: "",
      FamilyPostcode: "",
      FamilyRelationship: "",
      FamilyNoTel: "",
      FamilyFixPhoneNo: "",
      StudyInstituteName: "",
      EduInstituteName: "",

      AchievementResult: "",
      AchievementUnit: "",
      CourseName: "",

      FatherLivingStatus: "",
      MotherLivingStatus: "",
      GuardianLivingStatus: "",
      StartDt: "",

      //StatusHistory: {},
      History: {},
      Dependent: {},
      ProposedStudy: {},
      Intakes: {},

      Guarantor1: {},
      Guarantor2: {},
      InterviewZoneName: null,
      KokuMarks: null,
      SchoolName: null,
      SPMTurnNumber: null,
      StatusHistory: null,
      YTPCourse1Id: null,
      YTPCourse2Id: null,
      YTPCourse1Name: null,
      YTPCourse2Name: null,
      YTPCourse1IPT: null,
      YTPCourse2IPT: null,
      YTPCourseOfferId: null,
      YTPPath: null,
      sCFN: 'CetakBorangPermohonanYTP: ',
    };
    function calculate_age(dob) {
      var diff_ms = Date.now() - dob.getTime();
      var age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - this.PersonalBirthDt);
    }
  },
  async mounted() {
    let isAuth = await this.UserAuth();
    if (isAuth) {
      this.GetPersonalDetails();
      this.GetIntakes();
      await this.GetProposedStudy();
      await this.getYTPCourseInformation();
      await this.getGuarantors();
      this.GetHistoryDetails();
      await this.GetHighestEducation();
      await this.GetDependentDetails();
      await this.GetAge();
      await this.GetStatusHistory();
    }
  },
  computed: {
    durationYear: {
      get: function () {
        let year = Math.floor(this.durationMonth / 12);
        return year;
      },
    },
  },
  methods: {
    async getAddress(person) {
      let fN = 'getAddress: ';
      return this.$API
        .get(this.$PersonalAddress + "/" + person, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            return response.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetAge(dateString) {
      var today = new Date();
      var birthDt = new Date(dateString);
      var age = today.getFullYear() - birthDt.getFullYear();
      var m = today.getMonth() - birthDt.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDt.getDate())) {
        age--;
      }
      return age;
    },
    async getContactDetails(person) {
      let fN = 'getContactDetails: ';
      var url = {};
      if ("applicant" == person)
        url = this.$ContactDetails;
      else 
          url = this.$ContactDetails + "/" + person;
      return this.$API
        .get(url, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN 'response.data = ' + JSON.stringify(response.data))
            return response.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getCourseDescriptions(courseId) {
      return this.$API
        .get(this.$GetTwinProgram + "/" + courseId, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            return response.data;
          }
        });
    },
    async getCourseDetails(courseId) {
      return this.$API
        .get(this.$GetTwinProgramDetails + "/" + courseId, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            return response.data;
          }
        });
    },
    async GetDependentDetails() {
      return this.$API
        .get(this.$DependentDetails, { withCredentials: true })
        .then((response) => {
          this.Dependent = response.data;

          if (response.status == 200 && this.Dependent != null) {
            console.log(response);

            this.Name = this.Dependent.Name;
            this.BirthDt = this.Dependent.BirthDt;
            this.Sex = this.Dependent.Sex;
            this.RelationshipName = this.Dependent.RelationshipName;
            this.InstituteName = this.Dependent.InstituteName;
            this.Scholarship = this.Dependent.Scholarship;
            this.AcademicName = this.Dependent.AcademicName;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            //console.log(this.Dependent.detail);
          }
        });
    },
    async getEmploymentHistory(person) {
      let fN = 'getEmploymentHistory: ';
      return this.$API
        .get(this.$EmploymentHistory + "/" + person, { withCredentials: true, })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            return response.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getGuarantor(person) {
      let fN = 'getGuarantor: ';
      return this.$API
        .get(this.$PersonalDetails + "/" + person, { withCredentials: true, })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            return response.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getGuarantors() {
      let fN = 'getGuarantors: ';
      this.HTECHLogger(this.sCFN + fN + 'this.AppId = ' + this.AppId)
      var arr = null;
      if (0 < this.AppId) {
        let guarantor = 'guarantor1';
        arr = await this.getGuarantor(guarantor);
        this.Guarantor1.Name = arr.FirstName;
        this.Guarantor1.IdentityNo = arr.IdentityNo;
        arr = await this.getEmploymentHistory(guarantor);
        this.Guarantor1.MonthlyIncome = arr.MonthlyIncome;
        arr = await this.getAddress(guarantor);
        this.Guarantor1.Address = '';
        this.Guarantor1.Postcode = '';
        if (null != arr) {
          if (null != arr.Address1) this.Guarantor1.Address = arr.Address1 + ' ';
          if (null != arr.Address2) this.Guarantor1.Address += arr.Address2 + ' ';
          if (null != arr.Address3) this.Guarantor1.Address += arr.Address3 + ' ';
          if (null != arr.Postcode) this.Guarantor1.Postcode = arr.Postcode;
        }
        arr = await this.getContactDetails(guarantor);
        this.Guarantor1.MobileNo = arr.MobilePhoneNo;
        guarantor = 'guarantor2';
        arr = await this.getGuarantor(guarantor);
        this.Guarantor2.Name = arr.FirstName;
        this.Guarantor2.IdentityNo = arr.IdentityNo;
        arr = await this.getEmploymentHistory(guarantor);
        this.Guarantor2.MonthlyIncome = arr.MonthlyIncome;
        arr = await this.getAddress(guarantor);
        this.Guarantor2.Address = '';
        this.Guarantor2.Postcode = '';
        if (null != arr) {
          if (null != arr.Address1) this.Guarantor2.Address = arr.Address1 + ' ';
          if (null != arr.Address2) this.Guarantor2.Address += arr.Address2 + ' ';
          if (null != arr.Address3) this.Guarantor2.Address += arr.Address3 + ' ';
          if (null != arr.Postcode) this.Guarantor2.Postcode = arr.Postcode;
        }
        arr = await this.getContactDetails(guarantor);
        this.Guarantor2.MobileNo = arr.MobilePhoneNo;
      }
    },
    async GetHighestEducation() {
      return this.$API
        .get(this.$HighestEducation, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.EduHighestId = this.info.EduHighestId;
            this.EduInstituteName = this.info.EduHighestInstituteName;
            this.CourseName = this.info.EduHighestCourseName;
            this.StartDt = this.info.EduStartDt;
            this.EndDt = this.info.EduEndDt;
            this.AchievementUnit = this.info.AchievementUnitId;
            this.AchievementResult = this.info.AchievementResult;
            this.OtherAchievementUnit = this.info.OtherAchievementUnitId;
            this.OtherAchievementResult = this.info.OtherAchievementResult;
            this.SchoolName = this.info.SchoolName;
            this.SPMTurnNumber = this.info.SpmAngkaGiliran;
            this.KokuMarks = this.info.CocurriculumScore;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetHistoryDetails() {
      return this.$API
        .get(this.$EmploymentHistory, { withCredentials: true })
        .then((response) => {
          this.History = response.data;
          if (response.status == 200 && this.History != null) {
            console.log(response);
            this.Sector = this.History.Sector;
            this.TypeOfWork = this.History.TypeOfWork;
            this.EmployerName = this.History.EmployerName;
            this.Address1 = this.History.Address1;
            this.Address2 = this.History.Address2;
            this.Address3 = this.History.Address3;
            this.Postcode = this.History.Postcode;
            this.city = this.History.city;
            this.OtherStateName = this.History.OtherStateName;

            this.state = this.History.state;
            this.country = this.History.country;
            this.FixPhoneNo = this.History.FixPhoneNo;
            this.MonthlyIncome = this.History.MonthlyIncome;
            this.StartDt = this.History.StartDt;
            this.EndDt = this.History.StartDt;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            console.log(this.History.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetIntakes() {
      return this.$API
        .get(this.$IntakeAll, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Intakes = this.info;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetPersonalDetails() {
      let fN = 'GetPersonalDetails: ';
      return this.$API
        .get(this.$PersonalDetailsApplication, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            this.AppId = this.info.AppId;
            this.PersonalIdentityNo = this.info.PersonalIdentityNo;
            this.PersonalIdentityNoOther = this.info.PersonalIdentityNoOther;
            this.PersonalBirthDt = this.info.PersonalBirthDt;
            this.PersonalBirthState = this.info.PersonalBirthState;
            this.FirstName = this.info.FirstName;
            this.PersonalReligion = this.info.PersonalReligion;
            this.MaritalStatus = this.info.MaritalStatus;
            this.MaritalStatusName = this.info.MaritalStatusName;
            this.PersonalNationalityName = this.info.PersonalNationalityName;
            this.PersonalEthnic = this.info.PersonalEthnic;
            this.PersonalSex = this.info.PersonalSex;

            this.PersonalAddress1 = null != this.info.PersonalAddress1 ? this.info.PersonalAddress1.toUpperCase() : this.info.PersonalAddress1;
            this.PersonalAddress2 = null != this.info.PersonalAddress2 ? this.info.PersonalAddress2.toUpperCase() : this.info.PersonalAddress2;
            this.PersonalAddress3 = null != this.info.PersonalAddress3 ? this.info.PersonalAddress3.toUpperCase() : this.info.PersonalAddress3;
            this.PersonalPostCode = null != this.info.PersonalPostCode ? this.info.PersonalPostCode.toUpperCase() : this.info.PersonalPostCode;
            this.PersonalCity = null != this.info.PersonalCity ? this.info.PersonalCity.toUpperCase() : this.info.PersonalCity;
            this.PersonalState = null != this.info.PersonalState ? this.info.PersonalState.toUpperCase() : this.info.PersonalState;
            this.PersonalOtherStateName = null != this.info.PersonalOtherStateName ? this.info.PersonalOtherStateName.toUpperCase() : this.info.PersonalOtherStateName;
            this.PersonalCountry = null != this.info.PersonalCountry ? this.info.PersonalCountry.toUpperCase() : this.info.PersonalCountry;

            this.MailAddress1 = null != this.info.MailAddress1 ? this.info.MailAddress1.toUpperCase() : this.info.MailAddress1;
            this.MailAddress2 = null != this.info.MailAddress2 ? this.info.MailAddress2.toUpperCase() : this.info.MailAddress2;
            this.MailAddress3 = null != this.info.MailAddress3 ? this.info.MailAddress3.toUpperCase() : this.info.MailAddress3;
            this.MailPostCode = null != this.info.MailPostCode ? this.info.MailPostCode.toUpperCase() : this.info.MailPostCode;
            this.MailCities = null != this.info.MailCities ? this.info.MailCities.toUpperCase() : this.info.MailCities;
            this.MailStates = null != this.info.MailStates ? this.info.MailStates.toUpperCase() : this.info.MailStates;
            this.MailCountries = null != this.info.MailCountries ? this.info.MailCountries.toUpperCase() : this.info.MailCountries;

            this.PersonalMobileNo = this.info.PersonalMobileNo;
            this.PersonalFixPhoneNo = this.info.PersonalFixPhoneNo;
            this.PersonalEmail = this.info.PersonalEmail;

            this.BankName = this.info.BankName;
            this.BankNameOther = this.info.BankNameOther;
            this.BankAccountNo = this.info.BankAccountNo;

            this.FatherName = this.info.FatherName;
            this.FatherOldIdentityNo = this.info.FatherOldIdentityNo;
            this.FatherIdentityNo = this.info.FatherIdentityNo;
            this.FatherNoTel = this.info.FatherNoTel;
            this.FatherRetirementDt = this.info.FatherRetirementDt;
            this.FatherAddress1 = null != this.info.FatherAddress1 ? this.info.FatherAddress1.toUpperCase() : this.info.FatherAddress1;
            this.FatherAddress2 = null != this.info.FatherAddress2 ? this.info.FatherAddress2.toUpperCase() : this.info.FatherAddress2;
            this.FatherAddress3 = null != this.info.FatherAddress3 ? this.info.FatherAddress3.toUpperCase() : this.info.FatherAddress3;
            this.FatherCity = null != this.info.FatherCity ? this.info.FatherCity.toUpperCase() : this.info.FatherCity;
            this.FatherState = null != this.info.FatherState ? this.info.FatherState.toUpperCase() : this.info.FatherState;
            this.FatherPostcode = this.info.FatherPostcode;
            this.FatherCountry = null != this.info.FatherCountry ? this.info.FatherCountry.toUpperCase() : this.info.FatherCountry;
            this.FatherBirthDt = this.info.FatherBirthDt;
            this.FatherBirthState = null != this.info.FatherBirthState ? this.info.FatherBirthState.toUpperCase() : this.info.FatherBirthState;
            this.FatherBirthDtOtherState = this.info.FatherBirthDtOtherState;
            this.FatherNationalityName = this.info.FatherNationalityName;
            this.FatherReligion = this.info.FatherReligion;
            this.FatherEmployerName = this.info.FatherEmployerName;
            this.FatherSector = this.info.FatherSector;
            this.FatherTypeOfWork = this.info.FatherTypeOfWork;
            this.FatherEmploymentAddress1 = null != this.info.FatherEmploymentAddress1 ? this.info.FatherEmploymentAddress1.toUpperCase() : this.info.FatherEmploymentAddress1;
            this.FatherEmploymentAddress2 = null != this.info.FatherEmploymentAddress2 ? this.info.FatherEmploymentAddress2.toUpperCase() : this.info.FatherEmploymentAddress2;
            this.FatherEmploymentAddress3 = null != this.info.FatherEmploymentAddress3 ? this.info.FatherEmploymentAddress3.toUpperCase() : this.info.FatherEmploymentAddress3;
            this.FatherEmploymentCity = null != this.info.FatherEmploymentCity ? this.info.FatherEmploymentCity.toUpperCase() : this.info.FatherEmploymentCity;
            this.FatherEmploymentState = null != this.info.FatherEmploymentState ? this.info.FatherEmploymentState.toUpperCase() : this.info.FatherEmploymentState;
            this.FatherEmploymentCountry = null != this.info.FatherEmploymentCountry ? this.info.FatherEmploymentCountry.toUpperCase() : this.info.FatherEmploymentCountry;
            this.FatherEmploymentPostcode = this.info.FatherEmploymentPostcode;
            this.FatherEmploymentContact = this.info.FatherEmploymentContact;
            this.FatherMonthlyIncome = this.info.FatherMonthlyIncome;
            this.FatherYearlyIncome = this.info.FatherYearlyIncome;
            this.FatherOtherIncome = this.info.FatherOtherIncome;
            this.FatherIncomeTaxNo = this.info.FatherIncomeTaxNo;
            this.FatherLivingStatus = this.info.FatherLivingStatus;

            this.MotherName = this.info.MotherName;
            this.MotherOldIdentityNo = this.info.MotherOldIdentityNo;
            this.MotherIdentityNo = this.info.MotherIdentityNo;
            this.MotherNoTel = this.info.MotherNoTel;
            this.MotherRetirementDt = this.info.MotherRetirementDt;
            this.MotherAddress1 = null != this.info.MotherAddress1 ? this.info.MotherAddress1.toUpperCase() : this.info.MotherAddress1;
            this.MotherAddress2 = null != this.info.MotherAddress2 ? this.info.MotherAddress2.toUpperCase() : this.info.MotherAddress2;
            this.MotherAddress3 = null != this.info.MotherAddress3 ? this.info.MotherAddress3.toUpperCase() : this.info.MotherAddress3;
            this.MotherCity = null != this.info.MotherCity ? this.info.MotherCity.toUpperCase() : this.info.MotherCity;
            this.MotherState = null != this.info.MotherState ? this.info.MotherState.toUpperCase() : this.info.MotherState;
            this.MotherPostcode = this.info.MotherPostcode;
            this.MotherCountry = null != this.info.MotherCountry ? this.info.MotherCountry.toUpperCase() : this.info.MotherCountry;
            this.MotherBirthDt = this.info.MotherBirthDt;
            this.MotherBirthState = this.info.MotherBirthState;
            this.MotherBirthDtOtherState = this.info.MotherBirthDtOtherState;
            this.MotherNationalityName = this.info.MotherNationalityName;
            this.MotherReligion = this.info.MotherReligion;
            this.MotherEmployerName = this.info.MotherEmployerName;
            this.MotherSector = this.info.MotherSector;
            this.MotherTypeOfWork = this.info.MotherTypeOfWork;
            this.MotherEmploymentAddress1 = null != this.info.MotherEmploymentAddress1 ? this.info.MotherEmploymentAddress1.toUpperCase() : this.info.MotherEmploymentAddress1;
            this.MotherEmploymentAddress2 = null != this.info.MotherEmploymentAddress2 ? this.info.MotherEmploymentAddress2.toUpperCase() : this.info.MotherEmploymentAddress2;
            this.MotherEmploymentAddress3 = null != this.info.MotherEmploymentAddress3 ? this.info.MotherEmploymentAddress3.toUpperCase() : this.info.MotherEmploymentAddress3;
            this.MotherEmploymentCity = null != this.info.MotherEmploymentCity ? this.info.MotherEmploymentCity.toUpperCase() : this.info.MotherEmploymentCity;
            this.MotherEmploymentState = null != this.info.MotherEmploymentState ? this.info.MotherEmploymentState.toUpperCase() : this.info.MotherEmploymentState;
            this.MotherEmploymentCountry = null != this.info.MotherEmploymentCountry ? this.info.MotherEmploymentCountry.toUpperCase() : this.info.MotherEmploymentCountry;
            this.MotherEmploymentPostcode = this.info.MotherEmploymentPostcode;
            this.MotherEmploymentContact = this.info.MotherEmploymentContact;
            this.MotherMonthlyIncome = this.info.MotherMonthlyIncome;
            this.MotherYearlyIncome = this.info.MotherYearlyIncome;
            this.MotherOtherIncome = this.info.MotherOtherIncome;
            this.MotherIncomeTaxNo = this.info.MotherIncomeTaxNo;
            this.MotherLivingStatus = this.info.MotherLivingStatus;

            this.GuardianName = this.info.GuardianName;
            this.GuardianOldIdentityNo = this.info.GuardianOldIdentityNo;
            this.GuardianIdentityNo = this.info.GuardianIdentityNo;
            this.GuardianNoTel = this.info.GuardianNoTel;
            this.GuardianRetirementDt = this.info.GuardianRetirementDt;
            this.GuardianAddress1 = null != this.info.GuardianAddress1 ? this.info.GuardianAddress1.toUpperCase() : this.info.GuardianAddress1;
            this.GuardianAddress2 = null != this.info.GuardianAddress2 ? this.info.GuardianAddress2.toUpperCase() : this.info.GuardianAddress2;
            this.GuardianAddress3 = null != this.info.GuardianAddress3 ? this.info.GuardianAddress3.toUpperCase() : this.info.GuardianAddress3;
            this.GuardianCity = null != this.info.GuardianCity ? this.info.GuardianCity.toUpperCase() : this.info.GuardianCity;
            this.GuardianState = null != this.info.GuardianState ? this.info.GuardianState.toUpperCase() : this.info.GuardianState;
            this.GuardianPostcode = this.info.GuardianPostcode;
            this.GuardianCountry = null != this.info.GuardianCountry ? this.info.GuardianCountry.toUpperCase() : this.info.GuardianCountry;
            this.GuardianBirthDt = this.info.GuardianBirthDt;
            this.GuardianBirthState = this.info.GuardianBirthState;
            this.GuardianBirthDtOtherState = this.info.GuardianBirthDtOtherState;
            this.GuardianNationalityName = this.info.GuardianNationalityName;
            this.GuardianReligion = this.info.GuardianReligion;
            this.GuardianEmployerName = this.info.GuardianEmployerName;
            this.GuardianSector = this.info.GuardianSector;
            this.GuardianTypeOfWork = this.info.GuardianTypeOfWork;
            this.GuardianEmploymentAddress1 = null != this.info.GuardianEmploymentAddress1 ? this.info.GuardianEmploymentAddress1.toUpperCase() : this.info.GuardianEmploymentAddress1;
            this.GuardianEmploymentAddress2 = null != this.info.GuardianEmploymentAddress2 ? this.info.GuardianEmploymentAddress2.toUpperCase() : this.info.GuardianEmploymentAddress2;
            this.GuardianEmploymentAddress3 = null != this.info.GuardianEmploymentAddress3 ? this.info.GuardianEmploymentAddress3.toUpperCase() : this.info.GuardianEmploymentAddress3;
            this.GuardianEmploymentCity = null != this.info.GuardianEmploymentCity ? this.info.GuardianEmploymentCity.toUpperCase() : this.info.GuardianEmploymentCity;
            this.GuardianEmploymentState = null != this.info.GuardianEmploymentState ? this.info.GuardianEmploymentState.toUpperCase() : this.info.GuardianEmploymentState;
            this.GuardianEmploymentCountry = null != this.info.GuardianEmploymentCountry ? this.info.GuardianEmploymentCountry.toUpperCase() : this.info.GuardianEmploymentCountry;
            this.GuardianEmploymentPostcode = this.info.GuardianEmploymentPostcode;
            this.GuardianEmploymentContact = this.info.GuardianEmploymentContact;
            this.GuardianMonthlyIncome = this.info.GuardianMonthlyIncome;
            this.GuardianYearlyIncome = this.info.GuardianYearlyIncome;
            this.GuardianOtherIncome = this.info.GuardianOtherIncome;
            this.GuardianIncomeTaxNo = this.info.GuardianIncomeTaxNo;
            this.GuardianLivingStatus = this.info.GuardianLivingStatus;

            if ('BAPA' == this.info.Relationship) {
              this.GuardianName = this.FatherName;
              this.GuardianOldIdentityNo = this.FatherOldIdentityNo;
              this.GuardianIdentityNo = this.FatherIdentityNo;
              this.GuardianNoTel = this.FatherNoTel;
              this.GuardianRetirementDt = this.FatherRetirementDt;
              this.GuardianAddress1 = this.FatherAddress1;
              this.GuardianAddress2 = this.FatherAddress2;
              this.GuardianAddress3 = this.FatherAddress3;
              this.GuardianCity = this.FatherCity;
              this.GuardianState = this.FatherState;
              this.GuardianPostcode = this.FatherPostcode;
              this.GuardianCountry = this.FatherCountry;
              this.GuardianAddress1 = null != this.info.GuardianAddress1 ? this.info.GuardianAddress1.toUpperCase() : this.info.GuardianAddress1;
              this.GuardianAddress2 = null != this.info.GuardianAddress2 ? this.info.GuardianAddress2.toUpperCase() : this.info.GuardianAddress2;
              this.GuardianAddress3 = null != this.info.GuardianAddress3 ? this.info.GuardianAddress3.toUpperCase() : this.info.GuardianAddress3;
              this.GuardianCity = null != this.info.GuardianCity ? this.info.GuardianCity.toUpperCase() : this.info.GuardianCity;
              this.GuardianState = null != this.info.GuardianState ? this.info.GuardianState.toUpperCase() : this.info.GuardianState;
              this.GuardianPostcode = this.info.GuardianPostcode;
              this.GuardianCountry = null != this.info.GuardianCountry ? this.info.GuardianCountry.toUpperCase() : this.info.GuardianCountry;
              this.GuardianBirthDt = this.FatherBirthDt;
              this.GuardianBirthState = this.FatherBirthState;
              this.GuardianBirthDtOtherState = this.FatherBirthDtOtherState;
              this.GuardianNationalityName = this.FatherNationalityName;
              this.GuardianReligion = this.FatherReligion;
              this.GuardianEmployerName = this.FatherEmployerName;
              this.GuardianSector = this.FatherSector;
              this.GuardianTypeOfWork = this.FatherTypeOfWork;
              this.GuardianEmploymentAddress1 = this.FatherEmploymentAddress1;
              this.GuardianEmploymentAddress2 = this.FatherEmploymentAddress2;
              this.GuardianEmploymentAddress3 = this.FatherEmploymentAddress3;
              this.GuardianEmploymentCity = this.FatherEmploymentCity;
              this.GuardianEmploymentState = this.FatherEmploymentState;
              this.GuardianEmploymentCountry = this.FatherEmploymentCountry;
              this.GuardianEmploymentPostcode = this.FatherEmploymentPostcode;
              this.GuardianEmploymentContact = this.info.FatherEmploymentContact;
              this.GuardianEmploymentAddress1 = null != this.info.GuardianEmploymentAddress1 ? this.info.GuardianEmploymentAddress1.toUpperCase() : this.info.GuardianEmploymentAddress1;
              this.GuardianEmploymentAddress2 = null != this.info.GuardianEmploymentAddress2 ? this.info.GuardianEmploymentAddress2.toUpperCase() : this.info.GuardianEmploymentAddress2;
              this.GuardianEmploymentAddress3 = null != this.info.GuardianEmploymentAddress3 ? this.info.GuardianEmploymentAddress3.toUpperCase() : this.info.GuardianEmploymentAddress3;
              this.GuardianEmploymentCity = null != this.info.GuardianEmploymentCity ? this.info.GuardianEmploymentCity.toUpperCase() : this.info.GuardianEmploymentCity;
              this.GuardianEmploymentState = null != this.info.GuardianEmploymentState ? this.info.GuardianEmploymentState.toUpperCase() : this.info.GuardianEmploymentState;
              this.GuardianEmploymentCountry = null != this.info.GuardianEmploymentCountry ? this.info.GuardianEmploymentCountry.toUpperCase() : this.info.GuardianEmploymentCountry;
              this.GuardianMonthlyIncome = this.FatherMonthlyIncome;
              this.GuardianYearlyIncome = this.FatherYearlyIncome;
              this.GuardianOtherIncome = this.FatherOtherIncome;
              this.GuardianIncomeTaxNo = this.FatherIncomeTaxNo;
              this.GuardianLivingStatus = this.FatherLivingStatus;
            }

            if ('IBU' == this.info.Relationship) {
              this.GuardianName = this.MotherName;
              this.GuardianOldIdentityNo = this.MotherOldIdentityNo;
              this.GuardianIdentityNo = this.MotherIdentityNo;
              this.GuardianNoTel = this.MotherNoTel;
              this.GuardianRetirementDt = this.MotherRetirementDt;
              this.GuardianAddress1 = this.MotherAddress1;
              this.GuardianAddress2 = this.MotherAddress2;
              this.GuardianAddress3 = this.MotherAddress3;
              this.GuardianCity = this.MotherCity;
              this.GuardianState = this.MotherState;
              this.GuardianPostcode = this.MotherPostcode;
              this.GuardianCountry = this.MotherCountry;
              this.GuardianAddress1 = null != this.info.GuardianAddress1 ? this.info.GuardianAddress1.toUpperCase() : this.info.GuardianAddress1;
              this.GuardianAddress2 = null != this.info.GuardianAddress2 ? this.info.GuardianAddress2.toUpperCase() : this.info.GuardianAddress2;
              this.GuardianAddress3 = null != this.info.GuardianAddress3 ? this.info.GuardianAddress3.toUpperCase() : this.info.GuardianAddress3;
              this.GuardianCity = null != this.info.GuardianCity ? this.info.GuardianCity.toUpperCase() : this.info.GuardianCity;
              this.GuardianState = null != this.info.GuardianState ? this.info.GuardianState.toUpperCase() : this.info.GuardianState;
              this.GuardianPostcode = this.info.GuardianPostcode;
              this.GuardianCountry = null != this.info.GuardianCountry ? this.info.GuardianCountry.toUpperCase() : this.info.GuardianCountry;
              this.GuardianBirthDt = this.MotherBirthDt;
              this.GuardianBirthState = this.MotherBirthState;
              this.GuardianBirthDtOtherState = this.MotherBirthDtOtherState;
              this.GuardianNationalityName = this.MotherNationalityName;
              this.GuardianReligion = this.MotherReligion;
              this.GuardianEmployerName = this.MotherEmployerName;
              this.GuardianSector = this.MotherSector;
              this.GuardianTypeOfWork = this.FatherTypeOfWork;
              this.GuardianEmploymentAddress1 = this.MotherEmploymentAddress1;
              this.GuardianEmploymentAddress2 = this.MotherEmploymentAddress2;
              this.GuardianEmploymentAddress3 = this.MotherEmploymentAddress3;
              this.GuardianEmploymentCity = this.MotherEmploymentCity;
              this.GuardianEmploymentState = this.MotherEmploymentState;
              this.GuardianEmploymentCountry = this.MotherEmploymentCountry;
              this.GuardianEmploymentPostcode = this.MotherEmploymentPostcode;
              this.GuardianEmploymentContact = this.info.MotherEmploymentContact;
              this.GuardianEmploymentAddress1 = null != this.info.GuardianEmploymentAddress1 ? this.info.GuardianEmploymentAddress1.toUpperCase() : this.info.GuardianEmploymentAddress1;
              this.GuardianEmploymentAddress2 = null != this.info.GuardianEmploymentAddress2 ? this.info.GuardianEmploymentAddress2.toUpperCase() : this.info.GuardianEmploymentAddress2;
              this.GuardianEmploymentAddress3 = null != this.info.GuardianEmploymentAddress3 ? this.info.GuardianEmploymentAddress3.toUpperCase() : this.info.GuardianEmploymentAddress3;
              this.GuardianEmploymentCity = null != this.info.GuardianEmploymentCity ? this.info.GuardianEmploymentCity.toUpperCase() : this.info.GuardianEmploymentCity;
              this.GuardianEmploymentState = null != this.info.GuardianEmploymentState ? this.info.GuardianEmploymentState.toUpperCase() : this.info.GuardianEmploymentState;
              this.GuardianEmploymentCountry = null != this.info.GuardianEmploymentCountry ? this.info.GuardianEmploymentCountry.toUpperCase() : this.info.GuardianEmploymentCountry;
              this.GuardianMonthlyIncome = this.MotherMonthlyIncome;
              this.GuardianYearlyIncome = this.MotherYearlyIncome;
              this.GuardianOtherIncome = this.MotherOtherIncome;
              this.GuardianIncomeTaxNo = this.MotherIncomeTaxNo;
              this.GuardianLivingStatus = this.MotherLivingStatus;
            }

            this.SpouseName = this.info.SpouseName;
            this.SpouseOldIdentityNo = this.info.SpouseOldIdentityNo;
            this.SpouseIdentityNo = this.info.SpouseIdentityNo;
            this.SpouseBirthDt = this.info.SpouseBirthDt;
            this.SpouseBirthState = this.info.SpouseBirthState;
            this.SpouseBirthDtOtherState = this.info.SpouseBirthDtOtherState;
            this.SpouseNationalityName = this.info.SpouseNationalityName;
            this.SpouseReligion = this.info.SpouseReligion;
            this.SpouseNoTel = this.info.SpouseNoTel;
            this.SpouseFixPhoneNo = this.info.SpouseFixPhoneNo;
            this.SpouseAddress1 = null != this.info.SpouseAddress1 ? this.info.SpouseAddress1.toUpperCase() : this.info.SpouseAddress1;
            this.SpouseAddress2 = null != this.info.SpouseAddress2 ? this.info.SpouseAddress2.toUpperCase() : this.info.SpouseAddress2;
            this.SpouseAddress3 = null != this.info.SpouseAddress3 ? this.info.SpouseAddress3.toUpperCase() : this.info.SpouseAddress3;
            this.SpouseCity = null != this.info.SpouseCity ? this.info.SpouseCity.toUpperCase() : this.info.SpouseCity;
            this.SpouseState = null != this.info.SpouseState ? this.info.SpouseState.toUpperCase() : this.info.SpouseState;
            this.SpouseCountry = null != this.info.SpouseCountry ? this.info.SpouseCountry.toUpperCase() : this.info.SpouseCountry;
            this.SpousePostcode = this.info.SpousePostcode;
            this.SpouseSector = this.info.SpouseSector;
            this.SpouseTypeOfWork = this.info.SpouseTypeOfWork;
            this.SpouseEmployerName = this.info.SpouseEmployerName;
            this.SpouseEmploymentAddress1 = null != this.info.SpouseEmploymentAddress1 ? this.info.SpouseEmploymentAddress1.toUpperCase() : this.info.SpouseEmploymentAddress1;
            this.SpouseEmploymentAddress2 = null != this.info.SpouseEmploymentAddress2 ? this.info.SpouseEmploymentAddress2.toUpperCase() : this.info.SpouseEmploymentAddress2;
            this.SpouseEmploymentAddress3 = null != this.info.SpouseEmploymentAddress3 ? this.info.SpouseEmploymentAddress3.toUpperCase() : this.info.SpouseEmploymentAddress3;
            this.SpouseEmploymentCity = null != this.info.SpouseEmploymentCity ? this.info.SpouseEmploymentCity.toUpperCase() : this.info.SpouseEmploymentCity;
            this.SpouseEmploymentState = null != this.info.SpouseEmploymentState ? this.info.SpouseEmploymentState.toUpperCase() : this.info.SpouseEmploymentState;
            this.SpouseEmploymentCountry = null != this.info.SpouseEmploymentCountry ? this.info.SpouseEmploymentCountry.toUpperCase() : this.info.SpouseEmploymentCountry;
            this.SpouseEmploymentPostcode = this.info.SpouseEmploymentPostcode;
            this.SpouseEmploymentContact = this.info.SpouseEmploymentContact;
            this.SpouseMonthlyIncome = this.info.SpouseMonthlyIncome;
            this.SpouseYearlyIncome = this.info.SpouseYearlyIncome;
            this.SpouseOtherIncome = this.info.SpouseOtherIncome;
            this.SpouseIncomeTaxNo = this.info.SpouseIncomeTaxNo;

            this.FamilyName = this.info.FamilyName;
            this.FamilyAddress1 = null != this.info.FamilyAddress1 ? this.info.FamilyAddress1.toUpperCase() : this.info.FamilyAddress1;
            this.FamilyAddress2 = null != this.info.FamilyAddress2 ? this.info.FamilyAddress2.toUpperCase() : this.info.FamilyAddress2;
            this.FamilyAddress3 = null != this.info.FamilyAddress3 ? this.info.FamilyAddress3.toUpperCase() : this.info.FamilyAddress3;
            this.FamilyCity = null != this.info.FamilyCity ? this.info.FamilyCity.toUpperCase() : this.info.FamilyCity;
            this.FamilyState = null != this.info.FamilyState ? this.info.FamilyState.toUpperCase() : this.info.FamilyState;
            this.FamilyCountry = null != this.info.FamilyCountry ? this.info.FamilyCountry.toUpperCase() : this.info.FamilyCountry;
            this.FamilyPostcode = this.info.FamilyPostcode;
            this.FamilyRelationship = this.info.FamilyRelationship;
            this.FamilyNoTel = this.info.FamilyNoTel;
            this.FamilyFixPhoneNo = this.info.FamilyFixPhoneNo;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    async GetProposedStudy() {
      return this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            console.log(response);
            this.AppId = this.info.AppId;
            this.Intake = this.info.IntakeId;
            this.CourseDurationMonth = this.info.CourseDurationMonth;
            let arr = _.filter(this.Intakes, ["Id", this.Intake]);
            this.ProgrammeId = arr[0].ProgramId;
            this.ProgrammeName = arr[0].Name;
            this.InstituteId = this.info.InstituteId;
            this.EndDtCommon = this.info.EndDt;
            if (this.InstituteId == 0)
              this.StudyInstituteName = this.info.InstituteNameOther;
            else 
              this.StudyInstituteName = this.info.InstituteName;
            console.log((this.StudyInstituteNameOther = this.info.InstituteNameOther));
            this.FieldId = this.info.FieldId;
            if (this.FieldId == 9999)
              this.FieldName = this.info.FieldNameOther;
            else
              this.FieldName = this.info.FieldName;
            this.Course1Id = this.info.Course1Id;
            if (this.Course1Id == 9999)
              this.Course1Name = this.info.CourseNameOther;
            else
              this.Course1Name = this.info.Course1Name;
            this.Course1Code = this.info.Course1Code;
            this.StartDtCommon = this.info.StartDt;
            //this.durationMonth = info.Course1DurationMonth;
            this.YTPCourseOfferId = this.info.YTPCourseOfferId;
            this.InterviewZoneName = this.info.InterviewZoneName;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetStatusHistory() {
      let fN = 'GetStatusHistory: ';
      return this.$API
        .get(this.$StatusHistoryMain, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StatusHistory = this.info;
            //this.HTECHLogger(this.sCFN + fN + 'this.StatusHistory = ' + JSON.stringify(this.StatusHistory))
            this.ProgrammeId = this.StatusHistory[0].ProgramId;
            this.Intake = this.StatusHistory[0].IntakeId;
            // if (this.StatusHistory.length > 0) {
            //   this.$dialog.alert(
            //     "Terdapat permohonan sebelum ini di dalam sistem sila emel ke mara (rujuk emel id seperti yang diiklankan di Portal MARA di www.mara.gov.my untuk tukar status supaya permohonan saudara/i dapat diteruskan."
            //   );
            // }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getYTPApplicationInformation() {
      let fN = 'getYTPApplicationInformation: ';
      return this.$API
        .get(this.$GetYTPApplicationInformation, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            this.YtpId = response.data[0].Id;
            if (0 < response.data[0].CourseChoice1) {
              this.YTPCourse1Id = response.data[0].CourseChoice1;
            }
            if (0 < response.data[0].CourseChoice2) {
              this.YTPCourse2Id = response.data[0].CourseChoice2;
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getYTPCourseInformation() {
      await this.getYTPApplicationInformation();
      var arr = null;
      if (0 < this.YTPCourse1Id) {
        arr = await this.getCourseDetails(this.YTPCourse1Id);
        this.YTPCourse1Name = arr[0].Name;
        this.YTPCourse1IPT = arr[0].InstituteName;
      }
      if (0 < this.YTPCourse2Id) {
        arr = await this.getCourseDetails(this.YTPCourse2Id);
        this.YTPCourse2Name = arr[0].Name;
        this.YTPCourse2IPT = arr[0].InstituteName;
      }
      if (0 < this.YTPCourseOfferId) {
        arr = await this.getCourseDescriptions(this.YTPCourseOfferId);
        this.YTPPath = arr.Path;
      }
    },
    PrintSection() {
      this.$htmlToPaper("printSection");
    },
  },
};
</script>
